import { useEffect } from "react";
import X from "lucide-react/dist/esm/icons/x";

interface RulesSheetProps {
  open: boolean;
  hapticsEnabled: boolean;
  onToggleHaptics: () => void;
  onClose: () => void;
}

export function RulesSheet({ open, hapticsEnabled, onToggleHaptics, onClose }: RulesSheetProps) {
  useEffect(function manageRulesSheet() {
    if (!open) return;
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";

    function closeOnEscape(event: KeyboardEvent) {
      if (event.key === "Escape") onClose();
    }
    window.addEventListener("keydown", closeOnEscape);
    return function restorePage() {
      document.body.style.overflow = previousOverflow;
      window.removeEventListener("keydown", closeOnEscape);
    };
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div className="sheet-backdrop" role="presentation" onPointerDown={(event) => {
      if (event.target === event.currentTarget) onClose();
    }}>
      <section className="rules-sheet" role="dialog" aria-modal="true" aria-labelledby="rules-title">
        <header>
          <div>
            <span className="eyebrow">CHIN · POKER52</span>
            <h2 id="rules-title">Cómo se juega</h2>
          </div>
          <button className="icon-button" type="button" onClick={onClose} aria-label="Cerrar reglas" autoFocus>
            <X aria-hidden="true" size={22} />
          </button>
        </header>

        <ol className="rule-list">
          <li>
            <b>Jugá consecutivas</b>
            <p>Arrastrá una carta si es inmediatamente mayor o menor. El palo no importa y la escalera es circular: K–A–2.</p>
          </li>
          <li>
            <b>Apilá las iguales</b>
            <p>Si dos cartas personales tienen el mismo valor, se acumulan en una pila y se repone el espacio libre. Jugás siempre la carta superior.</p>
          </li>
          <li>
            <b>CARTA EN MANO</b>
            <p>Cuando te quedan seis cartas en total, sólo vos podés verlas. Elegí libremente cuál jugar; el rival únicamente ve cuántas conservás.</p>
          </li>
          <li>
            <b>Cantá CHIN</b>
            <p>Cuando las dos cartas centrales coinciden, tocá CHIN primero. El rival levanta ambos pozos. Después de un CHIN válido hay una ventana protegida: llegar tarde no suma otra penalización.</p>
          </li>
          <li>
            <b>Vaciá tu lado</b>
            <p>Ganás cuando no te queda ninguna carta en pilas, reserva ni mano. Un CHIN realmente falso hace que levantes ambos pozos.</p>
          </li>
        </ol>

        <div className="rules-note">
          <strong>Si nadie puede jugar</strong>
          <p>Quien tenga más cartas reinicia ambos pozos: pone dos cartas propias, una en cada pozo. El otro jugador no pone ninguna. Esto también ocurre después de un CHIN; si empatan, se alterna quién da.</p>
        </div>

        <label className="setting-row">
          <span>
            <strong>Vibración táctil</strong>
            <small>Una señal breve al jugar y cantar.</small>
          </span>
          <input type="checkbox" checked={hapticsEnabled} onChange={onToggleHaptics} />
          <i aria-hidden="true" />
        </label>

        <button className="primary-button" type="button" onClick={onClose}>Entendido</button>
      </section>
    </div>
  );
}
